<template>
    <div class="index-one mr-10">
        组件1：发送<el-button @click="sendMsg">asd</el-button>
    </div>
</template>
<script>
    import indexTransfer from '../../../assets/index-transfer.js'
    export default {
        data(){
            return {
                msg:1,
                num:0,
            }
        },
        methods:{
            sendMsg(){
                this.num++;
                indexTransfer.$emit('receiveComponemt', this.num)
            },
        }
    }
</script>
<style scoped>
    .index-one{
        width: 200px;
        height: 200px;
        line-height: 200px;
        float: left;
        border: 1px solid #f1f1f1;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/transfer-value/index-one.vue